<div data-sticky-container>
  <div id="masthead" class="masthead" data-sticky data-sticky-on="large" data-top-anchor="main-content-area:top" data-btm-anchor="main-content-area:bottom">
    <div class="masthead-inner head-row new-row">
      <!-- local-title -->
      <div class=" " id="local-title">
        <a  class="show-for-large" [routerLink]="['/']" title="Back to AlphaFold Protein Structure Database homepage">
          <h1>AlphaFold <span class="afLogoSubtitle">Protein Structure Database</span></h1>
        </a>
        <h1 class="hide-for-large" >
          <a [routerLink]="['/']" title="Back to AlphaFold Protein Structure Database homepage">AlphaFold<br><span class="afLogoSubtitle">Protein Structure Database</span>
          </a>
        </h1>

        <span style="display: flex; gap:15px; margin-right:12px;" *ngIf="!homePage">
          <span class="hide-for-large hide-for-medium" *ngIf="!homePage">
            <svg xmlns="http://www.w3.org/2000/svg" (click)="toggleSearch()"  *ngIf="!showSearchContainer"  width="21" height="20" viewBox="0 0 21 20" fill="none">
              <path d="M20.0123 17.164L16.1439 13.2934C17.3217 11.5292 17.8017 9.38976 17.4903 7.29116C17.1789 5.19255 16.0985 3.28485 14.4592 1.93914C12.8199 0.593434 10.7389 -0.0940673 8.621 0.0103678C6.50312 0.114803 4.49979 1.00371 3.00067 2.50418C1.50155 4.00464 0.613843 6.00939 0.510214 8.12847C0.406585 10.2475 1.09445 12.3294 2.44 13.9692C3.78555 15.6089 5.69258 16.6892 7.79015 17C9.88772 17.3109 12.0258 16.8299 13.7886 15.6507L17.6571 19.5205C17.9721 19.8279 18.3947 20 18.8347 20C19.2747 20 19.6973 19.8279 20.0123 19.5205C20.3246 19.208 20.5 18.7842 20.5 18.3422C20.5 17.9003 20.3246 17.4765 20.0123 17.164ZM9.04903 2.50993C10.2432 2.50993 11.4106 2.86424 12.4036 3.52806C13.3965 4.19189 14.1704 5.13541 14.6274 6.23931C15.0844 7.34321 15.204 8.55791 14.971 9.7298C14.738 10.9017 14.1629 11.9781 13.3185 12.823C12.4741 13.6679 11.3982 14.2433 10.227 14.4764C9.05573 14.7095 7.8417 14.5899 6.7384 14.1326C5.63511 13.6754 4.6921 12.901 4.02864 11.9076C3.36518 10.9141 3.01106 9.74606 3.01106 8.5512C3.01283 6.9495 3.64953 5.4139 4.78149 4.28132C5.91345 3.14875 7.4482 2.51169 9.04903 2.50993Z" fill="white"/>
            </svg>
            <svg class="mobile-menu-icon" viewBox="0 0 24 24" *ngIf="showSearchContainer" (click)="toggleSearch()">
              <path fill="currentColor" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
            </svg>
          </span>
  
  
          <svg class="mobile-menu-icon" viewBox="0 0 24 24" *ngIf="!menuOpen" (click)="toggleMenu()">
            <path fill="currentColor" d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" />
          </svg>
  
          <svg class="mobile-menu-icon" viewBox="0 0 24 24" *ngIf="menuOpen" (click)="toggleMenu()">
            <path fill="currentColor" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
          </svg>
        </span>

        <span style="display: flex; gap:15px; margin-right:12px;" *ngIf="homePage">
          <svg class="mobile-menu-icon" viewBox="0 0 24 24" *ngIf="!menuOpen" (click)="toggleMenu()">
            <path fill="currentColor" d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" />
          </svg>
  
          <svg class="mobile-menu-icon" viewBox="0 0 24 24" *ngIf="menuOpen" (click)="toggleMenu()">
            <path fill="currentColor" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
          </svg>
        </span>
      </div>

      <div class="hide-for-small-only">
        <nav class="master-nav">
          <ul id="local-nav" class="dropdown menu float-left" data-description="navigational">
            <li><a [routerLink]="['/']" routerLinkActive="active" [routerLinkActiveOptions]= "{exact: true}"
                   (click)="gaService.eventEmitter(
      'link_visit',
      'nav_href_click',
      'click',
      'home',
      '')">Home</a></li>
            <li><a id="about" [routerLink]="['about']" routerLinkActive="active"
                   (click)="gaService.eventEmitter(
      'link_visit',
      'nav_href_click',
      'click',
      'about',
      '')">About</a></li>
            <li><a [routerLink]="['faq']" routerLinkActive="active"
                   (click)="gaService.eventEmitter(
      'link_visit',
      'nav_href_click',
      'click',
      'faq',
      '')">FAQs</a></li>
            <li><a [routerLink]="['download']" routerLink="download" routerLinkActive="active"
                   (click)="gaService.eventEmitter(
      'link_visit',
      'nav_href_click',
      'click',
      'downloads',
      '')">Downloads</a></li>
            <li><a [routerLink]="['api-docs']" routerLink="api-docs" routerLinkActive="active"
                   (click)="gaService.eventEmitter(
      'link_visit',
      'nav_href_click',
      'click',
      'openapi',
      '')">API</a></li>
          </ul>
        </nav>
      </div>
      <div class="columns small-12 mobile-menu" *ngIf="menuOpen">
        <nav>
          <ul id="local-nav" class="dropdown menu" data-description="navigational">
            <li><a [routerLink]="['/']"  routerLinkActive="active" [routerLinkActiveOptions]= "{exact: true}">Home</a></li>
            <li><a id="about" [routerLink]="['about']" routerLinkActive="active">About</a></li>
            <li><a [routerLink]="['faq']" routerLinkActive="active">FAQs</a></li>
            <li><a [routerLink]="['download']" routerLink="download" routerLinkActive="active">Downloads</a></li>
            <li><a [routerLink]="['api-docs']" routerLink="api-docs" routerLinkActive="active">API</a></li>
           </ul>
        </nav>
      </div>
    </div>
  </div>

  <div class="header-search-section home-banner" *ngIf="homePage">
    <div class="row">
      <div class="columns small-12">
        <div class="homeBannerText">
          <h2 class="homeBannerTitle">AlphaFold<br class="hide-for-small-only"> Protein Structure Database</h2>
          <p class="homeBannerSubtitle">Developed by Google DeepMind and EMBL-EBI</p>
        </div>
        <div class="home-banner-search">
          <app-header-search [homePage]="homePage" ></app-header-search>
        </div>
      </div>
    </div>
  </div>

  <div class="header-search-section" *ngIf="!homePage">
    <div class="row new-row">
      
      <!-- Always visible on desktop -->
      <div class="small-12 search-container hide-for-small-only">
        <app-header-search [homePage]="homePage"></app-header-search>
      </div>
  
      <!-- Toggle-able version on mobile -->
      <div
        class="small-12 search-container hide-for-large"
        *ngIf="showSearchContainer"
      >
        <app-header-search [homePage]="homePage"></app-header-search>
      </div>
      
    </div>
  </div>
  
</div>
